import { Sparkles } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function Marquee() {
  const { content, lang } = useSite();
  const items = content.marquee?.[lang] || content.marquee?.es || [];
  const doubled = [...items, ...items];

  return (
    <div className="relative my-6 -rotate-1 scale-[1.02] overflow-hidden border-y-2 border-navy bg-volt py-4" data-testid="marquee">
      <div className="marquee-track items-center">
        {doubled.map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-8 whitespace-nowrap pr-8 font-display text-2xl uppercase tracking-widest text-navy"
          >
            {item}
            <Sparkles size={18} className="shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
}
